module.exports = __webpack_public_path__ + "static/media/8.9be8d57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/8.png
// module id = 1377
// module chunks = 0